import styled from "styled-components";

const Container = styled.div`
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 4;
    width: 100%;
    padding: 5px 20px;
    height: 50px;

    button {
        background-color: transparent;
    }

    .btn-return svg {
        fill: white;
        transform: rotate(180deg);
        width: 15px;
        height: 15px;
        margin-top: 15px;
    }

    .logo-partner {
        margin-top: 10px;
        padding-left: 20px;
    }

    .container {
        display: flex;
        justify-content: space-between;
    }

    img {
        height: 25px;
    }

    a {
        color: #fff !important;
        text-decoration: none;
    }

    .menu-bottom {
        background-color: #000;
    }

    .container-logo {
        margin-top: 8px;
    }

    .menu-mobile {
        margin: 0;
        margin-top: 5px;
    }

    a.btn {
        font-size: 8px;
        margin-bottom: 0;
        padding: 8px 10px;
        min-width: auto;
        width: 125px;
        height: 30px;
    }

    .menu-mobile .icon-menu {
        margin-top: 4px;
        padding-left: 10px;
    }

    .menu {
        display: none;
        flex: 1;
        text-align: right;
    }

    .menu li {
        display: inline-block;
    }
    .menu li a {
        padding: 23px;
    }

    .menu li a:hover {
        border-bottom: 2px solid white;
    }

    .welcome {
        display: inline-block;
    }

    .toggle-menu {
        display: inline;
    }

    @media (min-width: 1200px) {
        height: 65px;
        padding: 10px;

        a.btn {
            font-size: 12px;
            margin-top: -8px;
            width: 195px;
            height: 39px;
            margin-bottom: 0px;
            min-width: auto;
            padding: 10px;
        }

        img {
            height: 35px;
        }

        .menu {
            display: inline;
            margin-top: 9px;
            padding-top: 3px;
        }

        .container-logo {
            margin-top: 5px;
        }

        .menu-mobile a.icon-menu {
            display: none;
        }

        .menu-mobile {
            display: none;
        }

        .welcome,
        .toggle-menu {
            display: none;
        }
    }
`;

export default Container;
